"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __doc, __piles, __attachments;
var Sector_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sector = void 0;
const decorators_1 = require("./decorators");
const regex_1 = require("./regex");
let Sector = Sector_1 = class Sector {
    constructor(doc) {
        __doc.set(this, void 0);
        __piles.set(this, void 0);
        __attachments.set(this, void 0);
        __classPrivateFieldSet(this, __doc, doc);
    }
    static create(uid, data) {
        const numericIdMatch = uid.match(regex_1.sectorNumberRegex);
        if (numericIdMatch === null || (numericIdMatch && !numericIdMatch[1])) {
            throw new Error('Invalid sector UID, has no numeric component');
        }
        const doc = {
            _id: uid,
            id: numericIdMatch[1],
            created: new Date().toISOString(),
            name: (data === null || data === void 0 ? void 0 : data.name) || uid,
            roads: (data === null || data === void 0 ? void 0 : data.roads) || [],
            teams: (data === null || data === void 0 ? void 0 : data.teams) || [],
            operations: (data === null || data === void 0 ? void 0 : data.operations) || [],
            status: (data === null || data === void 0 ? void 0 : data.status) || 'open'
        };
        return new Sector_1(doc);
    }
    get uid() {
        return __classPrivateFieldGet(this, __doc)._id;
    }
    set uid(value) {
        if (!regex_1.sectorKeyRegex.test(value)) {
            throw new Error(`${value} is not a valid SectorUID`);
        }
        __classPrivateFieldGet(this, __doc)._id = value;
    }
    get id() {
        return __classPrivateFieldGet(this, __doc)._id.replace(/s\:/, '');
    }
    get name() {
        return __classPrivateFieldGet(this, __doc).name || '';
    }
    set name(value) {
        __classPrivateFieldGet(this, __doc).name = value;
    }
    get roads() {
        return __classPrivateFieldGet(this, __doc).roads || [];
    }
    set roads(value) {
        if (!Array.isArray(value)) {
            throw "Cannot assign to 'roads' because provided value is not an array";
        }
        __classPrivateFieldGet(this, __doc).roads = value;
    }
    get teams() {
        return __classPrivateFieldGet(this, __doc).teams || [];
    }
    set teams(value) {
        if (!Array.isArray(value)) {
            throw "Cannot assign to 'teams' because provided value is not an array";
        }
        __classPrivateFieldGet(this, __doc).teams = value;
    }
    get operations() {
        return __classPrivateFieldGet(this, __doc).operations || [];
    }
    set operations(value) {
        if (!Array.isArray(value)) {
            throw "Cannot assign to 'operations' because provided value is not an array";
        }
        __classPrivateFieldGet(this, __doc).operations = value;
    }
    get created() {
        if (!__classPrivateFieldGet(this, __doc).created) {
            __classPrivateFieldGet(this, __doc).created = (new Date()).toISOString();
        }
        return new Date(__classPrivateFieldGet(this, __doc).created);
    }
    set created(value) {
        if (typeof value == 'string') {
            value = (new Date(value)).toISOString();
        }
        __classPrivateFieldGet(this, __doc).created = value;
    }
    get closed() {
        if (!__classPrivateFieldGet(this, __doc).closed) {
            return undefined;
        }
        return new Date(__classPrivateFieldGet(this, __doc).closed);
    }
    set closed(value) {
        if (typeof value == 'string') {
            value = (new Date(value)).toISOString();
        }
        else if (!value) {
            return;
        }
        __classPrivateFieldGet(this, __doc).closed = value;
    }
    get status() {
        return __classPrivateFieldGet(this, __doc).status || 'open';
    }
    set status(value) {
        __classPrivateFieldGet(this, __doc).status = value;
    }
    get roadTypes() {
        return __classPrivateFieldGet(this, __doc).roadTypes || {};
    }
    set roadTypes(value) {
        __classPrivateFieldGet(this, __doc).roadTypes = value;
    }
    get roadInfo() {
        return __classPrivateFieldGet(this, __doc).roadInfo || {};
    }
    set roadInfo(value) {
        __classPrivateFieldGet(this, __doc).roadInfo = value;
    }
    linkPiles(piles) {
        __classPrivateFieldSet(this, __piles, piles);
    }
    linkAttachments(attachments) {
        __classPrivateFieldSet(this, __attachments, attachments);
    }
    unlinkPiles(piles) {
        __classPrivateFieldSet(this, __piles, undefined);
    }
    unlinkAttachments(attachments) {
        __classPrivateFieldSet(this, __attachments, undefined);
    }
    clone() {
        return new Sector_1(this.toDoc());
    }
    toDoc() {
        return Object.assign({
            roads: [],
            teams: [],
            operations: []
        }, __classPrivateFieldGet(this, __doc));
    }
    toJSON() {
        var _a;
        const jsonObj = {};
        // add all properties
        const proto = Object.getPrototypeOf(this);
        for (const key of Object.keys(proto)) {
            const desc = Object.getOwnPropertyDescriptor(proto, key);
            const hasGetter = desc && typeof desc.get === 'function';
            if (hasGetter) {
                jsonObj[key] = (_a = desc === null || desc === void 0 ? void 0 : desc.get) === null || _a === void 0 ? void 0 : _a.call(this);
            }
        }
        return jsonObj;
    }
};
__doc = new WeakMap(), __piles = new WeakMap(), __attachments = new WeakMap();
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Sector.prototype, "uid", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Sector.prototype, "id", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Sector.prototype, "name", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], Sector.prototype, "roads", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], Sector.prototype, "teams", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], Sector.prototype, "operations", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Sector.prototype, "created", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Sector.prototype, "closed", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Sector.prototype, "status", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Sector.prototype, "roadTypes", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Sector.prototype, "roadInfo", null);
Sector = Sector_1 = __decorate([
    decorators_1.Sealed(),
    __metadata("design:paramtypes", [Object])
], Sector);
exports.Sector = Sector;
